import { useId, useState } from 'react'
import * as Mtds from '@mattilsynet/design/react'
import type { Requisition } from '../../types/types'
import { useGetSampleByIdQuery } from '../../hooks/useSample'
import { useGetRequisitionByIdQuery } from '../../hooks/useRequisition'
import { ModalDialog } from '../modal-dialog/ModalDialog'
import { SampleCancellationForm } from './SampleCancellationForm'

export const SampleCancellationModal = ({
  requisition,
  sampleId,
  missingResultsOnly = false,
  onClose
}: {
  requisition: Requisition
  sampleId: string
  missingResultsOnly?: boolean
  onClose: () => void
}) => {
  const id = useId()
  const [pending, setPending] = useState(false)
  const sampleQuery = useGetSampleByIdQuery(sampleId)
  const requisitionQuery = useGetRequisitionByIdQuery(requisition.id)
  return (
    <ModalDialog
      id={id}
      open
      aria-labelledby={`${id}-title`}
      closedby={pending ? 'none' : 'any'}
      onClose={() => {
        if (!pending) onClose()
      }}
    >
      <Mtds.Button
        type='button'
        command='close'
        commandfor={id}
        aria-label='Lukk'
        disabled={pending}
      />
      <Mtds.Grid data-gap='5'>
        <Mtds.Heading as='h2' data-size='sm' id={`${id}-title`}>
          {missingResultsOnly ? 'Avklar manglende resultater' : 'Kansellering'}
        </Mtds.Heading>
        {sampleQuery.isError || requisitionQuery.isError ? (
          <Mtds.Alert data-color='danger'>
            Kunne ikke hente oppdatert prøvestatus. Lukk vinduet og prøv igjen.
          </Mtds.Alert>
        ) : !sampleQuery.data || !requisitionQuery.data ? (
          <p role='status'>Henter oppdatert prøvestatus …</p>
        ) : (
          <SampleCancellationForm
            missingResultsOnly={missingResultsOnly}
            sample={sampleQuery.data}
            requisition={requisitionQuery.data}
            onSuccess={onClose}
            onPendingChange={setPending}
          />
        )}
      </Mtds.Grid>
    </ModalDialog>
  )
}
